import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RdfCacheService} from "./rdf-cache.service";

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [RdfCacheService]
})
export class RdfDataSetModule { }
